export default {
    data() {
        return {
            scrolledIntoView: false,
            triggeredState: 0,
        };
    },
    computed: {
        refIsVisible: {
            get() {
                return this.scrolledIntoView;
            },
            set(Bool) {
                this.scrolledIntoView = Bool;
            },
        },
    },
    mounted() {
        document.getElementById('main-container').addEventListener('scroll', this.isScrolledIntoView);
        document.addEventListener('scroll', this.isScrolledIntoView);
    },
    beforeDestroy() {
        document.getElementById('main-container').removeEventListener('scroll', this.isScrolledIntoView);
        document.removeEventListener('scroll', this.isScrolledIntoView);
    },
    methods: {
        isScrolledIntoView() {
            if (this.$refs.monitorIfScrolledImage.getAttribute('data-animation') === 'offset') {
                this.offsetAnimation();
            } else {
                this.viewportAnimation();
            }
        },
        offsetAnimation() {
            // add ref to element in your template to monitor if it is scrolled into view
            const rect = this.$refs.monitorIfScrolledImage.getBoundingClientRect();

            const fadeInTrigger = rect.top + rect.bottom / 4;
            const fadeOutTrigger = rect.bottom + document.documentElement.clientHeight / 2;

            if (fadeInTrigger <= window.innerHeight || (fadeOutTrigger > window.innerHeight && this.triggeredState !== 0)) {
                if (this.triggeredState % 2 === 0) {
                    this.playAnimation(1);
                }
            }

            if (fadeOutTrigger <= window.innerHeight || fadeInTrigger > window.innerHeight) {
                if (this.triggeredState % 2 !== 0) {
                    this.playAnimation(0);
                }
            }
        },
        viewportAnimation() {
            // add ref to element in your template to monitor if it is scrolled into view
            const rect = this.$refs.monitorIfScrolledImage.getBoundingClientRect();
            const elemTop = rect.top;

            const isVisible = elemTop <= window.innerHeight;
            this.refIsVisible = isVisible;

            if (isVisible) {
                document.getElementById('main-container').removeEventListener('scroll', this.monitorIfScrolledImage);
                document.removeEventListener('scroll', this.monitorIfScrolledImage);
                // use this function to trigger the desired function
                this.isScrolledIntoViewAnimation(this.$refs.monitorIfScrolled);
            }
        },
        playAnimation(direction) {
            if (direction) {
                this.onEnter(this.$refs.monitorIfScrolled);
            } else {
                this.onExit(this.$refs.monitorIfScrolled);
            }

            if (this.triggeredState < 3) {
                this.triggeredState++;
            } else {
                this.triggeredState = 0;
            }
        },
    },
};
